var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3469 7.23004H35.9464V35.2566H27.3469V7.23004Z",
    fill: "#324395"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3281 16.7003H24.9276V35.2567H16.3281V16.7003Z",
    fill: "#324395"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29932 22.2824H13.8988V35.2561H5.29932V22.2824Z",
    fill: "#324395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/ChartIcon.966583d866c3cd138881dac09ee98368.svg";
export { ForwardRef as ReactComponent };